// extracted by mini-css-extract-plugin
export default {"pagina":"DetalhesPedido_pagina__x6q7N","mensagem":"DetalhesPedido_mensagem__88nPl"};